module.exports = __webpack_public_path__ + "img/enigmatic_synthesis.86ed1ae3.jpg";